"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decorationAdActionApi = decorationAdActionApi;
exports.decorationAdListApi = decorationAdListApi;
exports.decorationAdResultListApi = decorationAdResultListApi;
exports.decorationAdSaveApi = decorationAdSaveApi;
exports.decorationAdSlotActionApi = decorationAdSlotActionApi;
exports.decorationAdSlotApi = decorationAdSlotApi;
exports.decorationAiActionApi = decorationAiActionApi;
exports.decorationAiListApi = decorationAiListApi;
exports.decorationAiSaveApi = decorationAiSaveApi;
exports.decorationAllianceProductActionApi = decorationAllianceProductActionApi;
exports.decorationAllianceProductListApi = decorationAllianceProductListApi;
exports.decorationAllianceProductSaveApi = decorationAllianceProductSaveApi;
exports.decorationApprovalActionApi = decorationApprovalActionApi;
exports.decorationApprovalListApi = decorationApprovalListApi;
exports.decorationApprovalSaveApi = decorationApprovalSaveApi;
exports.decorationAssetActionApi = decorationAssetActionApi;
exports.decorationAssetListApi = decorationAssetListApi;
exports.decorationAssetSaveApi = decorationAssetSaveApi;
exports.decorationBasicProfileActionApi = decorationBasicProfileActionApi;
exports.decorationBasicProfileListApi = decorationBasicProfileListApi;
exports.decorationBasicProfileSaveApi = decorationBasicProfileSaveApi;
exports.decorationBehaviorActionApi = decorationBehaviorActionApi;
exports.decorationBehaviorListApi = decorationBehaviorListApi;
exports.decorationBehaviorSaveApi = decorationBehaviorSaveApi;
exports.decorationCameraActionApi = decorationCameraActionApi;
exports.decorationCameraCreateApi = decorationCameraCreateApi;
exports.decorationCameraDetailApi = decorationCameraDetailApi;
exports.decorationCameraListApi = decorationCameraListApi;
exports.decorationCampaignActionApi = decorationCampaignActionApi;
exports.decorationCampaignListApi = decorationCampaignListApi;
exports.decorationCampaignSaveApi = decorationCampaignSaveApi;
exports.decorationCompanySupplierActionApi = decorationCompanySupplierActionApi;
exports.decorationCompanySupplierListApi = decorationCompanySupplierListApi;
exports.decorationCompanySupplierPlatformOptionsApi = decorationCompanySupplierPlatformOptionsApi;
exports.decorationCompanySupplierSaveApi = decorationCompanySupplierSaveApi;
exports.decorationCompanySupplierUpdateApi = decorationCompanySupplierUpdateApi;
exports.decorationComplaintActionApi = decorationComplaintActionApi;
exports.decorationComplaintListApi = decorationComplaintListApi;
exports.decorationContentActionApi = decorationContentActionApi;
exports.decorationContentListApi = decorationContentListApi;
exports.decorationContentSaveApi = decorationContentSaveApi;
exports.decorationDashboardApi = decorationDashboardApi;
exports.decorationDesignerRecruitActionApi = decorationDesignerRecruitActionApi;
exports.decorationDesignerRecruitListApi = decorationDesignerRecruitListApi;
exports.decorationDesignerRecruitSaveApi = decorationDesignerRecruitSaveApi;
exports.decorationDocDownloadActionApi = decorationDocDownloadActionApi;
exports.decorationDocDownloadListApi = decorationDocDownloadListApi;
exports.decorationDocDownloadSaveApi = decorationDocDownloadSaveApi;
exports.decorationDocumentListApi = decorationDocumentListApi;
exports.decorationDocumentPdfApi = decorationDocumentPdfApi;
exports.decorationFollowLogListApi = decorationFollowLogListApi;
exports.decorationGroupPurchaseActionApi = decorationGroupPurchaseActionApi;
exports.decorationGroupPurchaseListApi = decorationGroupPurchaseListApi;
exports.decorationGroupPurchaseSaveApi = decorationGroupPurchaseSaveApi;
exports.decorationHotlineActionApi = decorationHotlineActionApi;
exports.decorationHotlineListApi = decorationHotlineListApi;
exports.decorationHotlineSaveApi = decorationHotlineSaveApi;
exports.decorationIdentityApi = decorationIdentityApi;
exports.decorationKpiActionApi = decorationKpiActionApi;
exports.decorationKpiListApi = decorationKpiListApi;
exports.decorationKpiSaveApi = decorationKpiSaveApi;
exports.decorationLeadAssignApi = decorationLeadAssignApi;
exports.decorationLeadListApi = decorationLeadListApi;
exports.decorationLeadRecycleStaleApi = decorationLeadRecycleStaleApi;
exports.decorationLeadStaffOptionsApi = decorationLeadStaffOptionsApi;
exports.decorationLedgerAccountListApi = decorationLedgerAccountListApi;
exports.decorationLedgerCommissionActionApi = decorationLedgerCommissionActionApi;
exports.decorationLedgerCommissionListApi = decorationLedgerCommissionListApi;
exports.decorationLedgerCommissionSaveApi = decorationLedgerCommissionSaveApi;
exports.decorationLedgerPostApi = decorationLedgerPostApi;
exports.decorationLedgerReceivableListApi = decorationLedgerReceivableListApi;
exports.decorationLedgerReconActionApi = decorationLedgerReconActionApi;
exports.decorationLedgerReconListApi = decorationLedgerReconListApi;
exports.decorationLedgerReconSaveApi = decorationLedgerReconSaveApi;
exports.decorationLedgerSummaryApi = decorationLedgerSummaryApi;
exports.decorationLedgerTransactionListApi = decorationLedgerTransactionListApi;
exports.decorationMallCategoryActionApi = decorationMallCategoryActionApi;
exports.decorationMallCategoryApi = decorationMallCategoryApi;
exports.decorationMerchantAuthActionApi = decorationMerchantAuthActionApi;
exports.decorationMerchantAuthListApi = decorationMerchantAuthListApi;
exports.decorationMerchantAuthSaveApi = decorationMerchantAuthSaveApi;
exports.decorationNotificationActionApi = decorationNotificationActionApi;
exports.decorationNotificationListApi = decorationNotificationListApi;
exports.decorationNotificationSaveApi = decorationNotificationSaveApi;
exports.decorationOpenGuideActionApi = decorationOpenGuideActionApi;
exports.decorationOpenGuideApi = decorationOpenGuideApi;
exports.decorationOrderDeliveryListApi = decorationOrderDeliveryListApi;
exports.decorationOrderSettlementListApi = decorationOrderSettlementListApi;
exports.decorationOutletActionApi = decorationOutletActionApi;
exports.decorationOutletListApi = decorationOutletListApi;
exports.decorationOutletSaveApi = decorationOutletSaveApi;
exports.decorationOwnerApplyActionApi = decorationOwnerApplyActionApi;
exports.decorationOwnerApplyListApi = decorationOwnerApplyListApi;
exports.decorationPackageActionApi = decorationPackageActionApi;
exports.decorationPackageListApi = decorationPackageListApi;
exports.decorationPackageSaveApi = decorationPackageSaveApi;
exports.decorationPartnerActionApi = decorationPartnerActionApi;
exports.decorationPartnerListApi = decorationPartnerListApi;
exports.decorationPartnerSaveApi = decorationPartnerSaveApi;
exports.decorationPlatformRuleActionApi = decorationPlatformRuleActionApi;
exports.decorationPlatformRuleApi = decorationPlatformRuleApi;
exports.decorationPointsGoodsActionApi = decorationPointsGoodsActionApi;
exports.decorationPointsGoodsListApi = decorationPointsGoodsListApi;
exports.decorationPointsGoodsSaveApi = decorationPointsGoodsSaveApi;
exports.decorationPointsRedeemActionApi = decorationPointsRedeemActionApi;
exports.decorationPointsRedeemListApi = decorationPointsRedeemListApi;
exports.decorationPricingActionApi = decorationPricingActionApi;
exports.decorationPricingListApi = decorationPricingListApi;
exports.decorationPricingSaveApi = decorationPricingSaveApi;
exports.decorationProjectListApi = decorationProjectListApi;
exports.decorationPurchaseOrderActionApi = decorationPurchaseOrderActionApi;
exports.decorationPurchaseOrderDetailApi = decorationPurchaseOrderDetailApi;
exports.decorationPurchaseOrderListApi = decorationPurchaseOrderListApi;
exports.decorationReferralActionApi = decorationReferralActionApi;
exports.decorationReferralListApi = decorationReferralListApi;
exports.decorationReferralRuleActionApi = decorationReferralRuleActionApi;
exports.decorationReferralRuleListApi = decorationReferralRuleListApi;
exports.decorationReferralRuleSaveApi = decorationReferralRuleSaveApi;
exports.decorationReferralSaveApi = decorationReferralSaveApi;
exports.decorationRenovationLoanActionApi = decorationRenovationLoanActionApi;
exports.decorationRenovationLoanListApi = decorationRenovationLoanListApi;
exports.decorationRenovationPlanActionApi = decorationRenovationPlanActionApi;
exports.decorationRenovationPlanListApi = decorationRenovationPlanListApi;
exports.decorationRenovationPlanSaveApi = decorationRenovationPlanSaveApi;
exports.decorationReportActionApi = decorationReportActionApi;
exports.decorationReportCommentApi = decorationReportCommentApi;
exports.decorationReportDetailApi = decorationReportDetailApi;
exports.decorationReportListApi = decorationReportListApi;
exports.decorationReviewActionApi = decorationReviewActionApi;
exports.decorationReviewListApi = decorationReviewListApi;
exports.decorationRewardActionApi = decorationRewardActionApi;
exports.decorationRewardListApi = decorationRewardListApi;
exports.decorationRewardSaveApi = decorationRewardSaveApi;
exports.decorationRoleActionApi = decorationRoleActionApi;
exports.decorationRoleListApi = decorationRoleListApi;
exports.decorationRoleSaveApi = decorationRoleSaveApi;
exports.decorationSalesOrderActionApi = decorationSalesOrderActionApi;
exports.decorationSalesOrderCreateApi = decorationSalesOrderCreateApi;
exports.decorationSalesOrderDetailApi = decorationSalesOrderDetailApi;
exports.decorationSalesOrderListApi = decorationSalesOrderListApi;
exports.decorationScheduleListApi = decorationScheduleListApi;
exports.decorationSettingListApi = decorationSettingListApi;
exports.decorationShopStatusActionApi = decorationShopStatusActionApi;
exports.decorationShopStatusApi = decorationShopStatusApi;
exports.decorationShopStatusLogsApi = decorationShopStatusLogsApi;
exports.decorationSiteBasicListApi = decorationSiteBasicListApi;
exports.decorationSiteBasicUpdateApi = decorationSiteBasicUpdateApi;
exports.decorationSiteTeamActionApi = decorationSiteTeamActionApi;
exports.decorationSiteTeamListApi = decorationSiteTeamListApi;
exports.decorationSiteTeamSaveApi = decorationSiteTeamSaveApi;
exports.decorationStaffActionApi = decorationStaffActionApi;
exports.decorationStaffListApi = decorationStaffListApi;
exports.decorationStaffSaveApi = decorationStaffSaveApi;
exports.decorationStoreActionApi = decorationStoreActionApi;
exports.decorationStoreListApi = decorationStoreListApi;
exports.decorationStoreSaveApi = decorationStoreSaveApi;
exports.decorationSupervisionTeamActionApi = decorationSupervisionTeamActionApi;
exports.decorationSupervisionTeamListApi = decorationSupervisionTeamListApi;
exports.decorationSupervisionTeamSaveApi = decorationSupervisionTeamSaveApi;
exports.decorationTodoListApi = decorationTodoListApi;
exports.decorationTodoRebuildApi = decorationTodoRebuildApi;
exports.decorationTodoSummaryApi = decorationTodoSummaryApi;
exports.decorationWarningActionApi = decorationWarningActionApi;
exports.decorationWarningListApi = decorationWarningListApi;
exports.decorationWarningSaveApi = decorationWarningSaveApi;
exports.decorationWorkOrderActionApi = decorationWorkOrderActionApi;
exports.decorationWorkOrderCreateApi = decorationWorkOrderCreateApi;
exports.decorationWorkOrderDetailApi = decorationWorkOrderDetailApi;
exports.decorationWorkOrderListApi = decorationWorkOrderListApi;
var _request = _interopRequireDefault(require("@/utils/request"));
var _axios = _interopRequireDefault(require("axios"));
var _store = _interopRequireDefault(require("@/store"));
var _settingMer = _interopRequireDefault(require("@/utils/settingMer"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | 装企后台接口
// +----------------------------------------------------------------------

/**
 * 当前商户的装修意向线索
 */
function decorationLeadListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/lead/list',
    method: 'get',
    params: params
  });
}

/**
 * 当前商户可分配的装企职员
 */
function decorationLeadStaffOptionsApi() {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/lead/staff/options',
    method: 'get'
  });
}

/**
 * 将待分配线索分配给装企职员
 */
function decorationLeadAssignApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/lead/assign',
    method: 'post',
    data: data
  });
}
function decorationLeadRecycleStaleApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/lead/recycle-stale',
    method: 'post',
    data: data
  });
}

/**
 * 当前商户的装企工地项目
 */
function decorationProjectListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/project/list',
    method: 'get',
    params: params
  });
}
function decorationOrderDeliveryListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/order-delivery/list',
    method: 'get',
    params: params
  });
}

/**
 * 当前商户的施工工期台账
 */
function decorationScheduleListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/schedule/list',
    method: 'get',
    params: params
  });
}

/**
 * 当前商户的确认、延期与变更单台账
 */
function decorationDocumentListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/document/list',
    method: 'get',
    params: params
  });
}

/**
 * 下载工地业务单据 PDF
 */
function decorationDocumentPdfApi(id) {
  var token = _store.default.getters.token || sessionStorage.getItem('token');
  return (0, _axios.default)({
    baseURL: _settingMer.default.apiBaseURL,
    url: "/admin/merchant/decoration/document/".concat(id, "/pdf"),
    method: 'get',
    responseType: 'blob',
    headers: token ? {
      'Authori-zation': token
    } : {}
  });
}
function decorationReportListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/report/list',
    method: 'get',
    params: params
  });
}
function decorationReportDetailApi(id) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/report/".concat(id),
    method: 'get'
  });
}
function decorationReportActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/report/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationReportCommentApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/report/".concat(id, "/comment"),
    method: 'post',
    data: data
  });
}
function decorationCameraListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/camera/list',
    method: 'get',
    params: params
  });
}
function decorationCameraDetailApi(id) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/camera/".concat(id),
    method: 'get'
  });
}
function decorationCameraCreateApi(projectId, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/camera/project/".concat(projectId),
    method: 'post',
    data: data
  });
}
function decorationCameraActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/camera/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationSalesOrderListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/material/sales-order/list',
    method: 'get',
    params: params
  });
}
function decorationSalesOrderDetailApi(id) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/material/sales-order/".concat(id),
    method: 'get'
  });
}
function decorationSalesOrderActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/material/sales-order/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationPurchaseOrderListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/material/purchase/list',
    method: 'get',
    params: params
  });
}
function decorationPurchaseOrderDetailApi(id) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/material/purchase/".concat(id),
    method: 'get'
  });
}
function decorationPurchaseOrderActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/material/purchase/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationSalesOrderCreateApi(projectId, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/material/sales-order/project/".concat(projectId),
    method: 'post',
    data: data
  });
}
function decorationOrderSettlementListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/material/settlement/list',
    method: 'get',
    params: params
  });
}
function decorationTodoListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/todo/list',
    method: 'get',
    params: params
  });
}
function decorationTodoSummaryApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/todo/summary',
    method: 'get',
    params: params
  });
}
function decorationTodoRebuildApi() {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/todo/rebuild',
    method: 'post'
  });
}
function decorationWorkOrderListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/work-order/list',
    method: 'get',
    params: params
  });
}
function decorationWorkOrderDetailApi(id) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/work-order/".concat(id),
    method: 'get'
  });
}
function decorationWorkOrderCreateApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/work-order',
    method: 'post',
    data: data
  });
}
function decorationWorkOrderActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/work-order/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationReviewListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/review/list',
    method: 'get',
    params: params
  });
}
function decorationReviewActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/review/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationComplaintListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/complaint/list',
    method: 'get',
    params: params
  });
}
function decorationComplaintActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/complaint/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationLedgerSummaryApi() {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/ledger/summary',
    method: 'get'
  });
}
function decorationLedgerAccountListApi() {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/ledger/account/list',
    method: 'get'
  });
}
function decorationLedgerTransactionListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/ledger/transaction/list',
    method: 'get',
    params: params
  });
}
function decorationLedgerReceivableListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/ledger/receivable/list',
    method: 'get',
    params: params
  });
}
function decorationLedgerReconListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/ledger/reconciliation/list',
    method: 'get',
    params: params
  });
}
function decorationLedgerCommissionListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/ledger/commission/list',
    method: 'get',
    params: params
  });
}
function decorationLedgerPostApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/ledger/transaction',
    method: 'post',
    data: data
  });
}
function decorationLedgerReconSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/ledger/reconciliation',
    method: 'post',
    data: data
  });
}
function decorationLedgerReconActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/ledger/reconciliation/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationLedgerCommissionSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/ledger/commission',
    method: 'post',
    data: data
  });
}
function decorationLedgerCommissionActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/ledger/commission/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationKpiListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/kpi/list',
    method: 'get',
    params: params
  });
}
function decorationKpiSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/kpi',
    method: 'post',
    data: data
  });
}
function decorationKpiActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/kpi/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationRewardListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/reward/list',
    method: 'get',
    params: params
  });
}
function decorationRewardSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/reward',
    method: 'post',
    data: data
  });
}
function decorationRewardActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/reward/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationPartnerListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/partner/list',
    method: 'get',
    params: params
  });
}
function decorationPartnerSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/partner',
    method: 'post',
    data: data
  });
}
function decorationPartnerActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/partner/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationCompanySupplierListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/company-supplier/list',
    method: 'get',
    params: params
  });
}
function decorationCompanySupplierPlatformOptionsApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/company-supplier/platform/options',
    method: 'get',
    params: params
  });
}
function decorationCompanySupplierSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/company-supplier',
    method: 'post',
    data: data
  });
}
function decorationCompanySupplierUpdateApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/company-supplier/".concat(id),
    method: 'post',
    data: data
  });
}
function decorationCompanySupplierActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/company-supplier/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationAdListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/ad/list',
    method: 'get',
    params: params
  });
}
function decorationAdResultListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/ad/result/list',
    method: 'get',
    params: params
  });
}
function decorationAdSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/ad',
    method: 'post',
    data: data
  });
}
function decorationAdActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/ad/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationCampaignListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/campaign/list',
    method: 'get',
    params: params
  });
}
function decorationCampaignSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/campaign',
    method: 'post',
    data: data
  });
}
function decorationCampaignActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/campaign/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationReferralListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/referral/list',
    method: 'get',
    params: params
  });
}
function decorationReferralSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/referral',
    method: 'post',
    data: data
  });
}
function decorationReferralActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/referral/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationRenovationLoanListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/renovation-loan/application/list',
    method: 'get',
    params: params
  });
}
function decorationRenovationLoanActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/renovation-loan/application/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationStaffListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/org/staff/list',
    method: 'get',
    params: params
  });
}
function decorationRoleListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/org/role/list',
    method: 'get',
    params: params
  });
}
function decorationStaffSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/org/staff',
    method: 'post',
    data: data
  });
}
function decorationRoleSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/org/role',
    method: 'post',
    data: data
  });
}
function decorationStaffActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/org/staff/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationRoleActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/org/role/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationContentListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/content/list',
    method: 'get',
    params: params
  });
}
function decorationContentSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/content',
    method: 'post',
    data: data
  });
}
function decorationContentActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/content/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationPackageListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/package/list',
    method: 'get',
    params: params
  });
}
function decorationPackageSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/package',
    method: 'post',
    data: data
  });
}
function decorationPackageActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/package/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationAiListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/ai/list',
    method: 'get',
    params: params
  });
}
function decorationAiSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/ai',
    method: 'post',
    data: data
  });
}
function decorationAiActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/ai/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationBehaviorListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/behavior/list',
    method: 'get',
    params: params
  });
}
function decorationBehaviorSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/behavior',
    method: 'post',
    data: data
  });
}
function decorationBehaviorActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/behavior/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationAssetListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/asset/list',
    method: 'get',
    params: params
  });
}
function decorationAssetSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/asset',
    method: 'post',
    data: data
  });
}
function decorationAssetActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/asset/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationStoreListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/store/list',
    method: 'get',
    params: params
  });
}
function decorationStoreSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/store',
    method: 'post',
    data: data
  });
}
function decorationStoreActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/store/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationDashboardApi() {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/dashboard',
    method: 'get'
  });
}
function decorationIdentityApi() {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/identity',
    method: 'get'
  });
}
function decorationWarningListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/warning/list',
    method: 'get',
    params: params
  });
}
function decorationWarningSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/warning',
    method: 'post',
    data: data
  });
}
function decorationWarningActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/warning/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationSettingListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/setting/list',
    method: 'get',
    params: params
  });
}
function decorationNotificationListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/notification/list',
    method: 'get',
    params: params
  });
}
function decorationNotificationSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/notification',
    method: 'post',
    data: data
  });
}
function decorationNotificationActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/notification/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationOutletListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/outlet/list',
    method: 'get',
    params: params
  });
}
function decorationOutletSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/outlet',
    method: 'post',
    data: data
  });
}
function decorationOutletActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/outlet/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationFollowLogListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/follow-log/list',
    method: 'get',
    params: params
  });
}
function decorationApprovalListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/approval/list',
    method: 'get',
    params: params
  });
}
function decorationApprovalSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/approval',
    method: 'post',
    data: data
  });
}
function decorationApprovalActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/approval/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationHotlineListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/hotline/list',
    method: 'get',
    params: params
  });
}
function decorationHotlineSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/hotline',
    method: 'post',
    data: data
  });
}
function decorationHotlineActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/hotline/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationGroupPurchaseListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/group-purchase/list',
    method: 'get',
    params: params
  });
}
function decorationGroupPurchaseSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/group-purchase',
    method: 'post',
    data: data
  });
}
function decorationGroupPurchaseActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/group-purchase/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationPricingListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/pricing/list',
    method: 'get',
    params: params
  });
}
function decorationPricingSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/pricing',
    method: 'post',
    data: data
  });
}
function decorationPricingActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/pricing/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationAllianceProductListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/alliance-product/list',
    method: 'get',
    params: params
  });
}
function decorationAllianceProductSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/alliance-product',
    method: 'post',
    data: data
  });
}
function decorationAllianceProductActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/alliance-product/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationMerchantAuthListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/merchant-auth/list',
    method: 'get',
    params: params
  });
}
function decorationMerchantAuthSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/merchant-auth',
    method: 'post',
    data: data
  });
}
function decorationMerchantAuthActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/merchant-auth/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationShopStatusApi() {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/shop-status',
    method: 'get'
  });
}
function decorationShopStatusActionApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/shop-status/action',
    method: 'post',
    data: data
  });
}
function decorationShopStatusLogsApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/shop-status/logs',
    method: 'get',
    params: params
  });
}
function decorationOpenGuideApi() {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/open-guide',
    method: 'get'
  });
}
function decorationOpenGuideActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/open-guide/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationPointsGoodsListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/points-mall/goods/list',
    method: 'get',
    params: params
  });
}
function decorationPointsGoodsSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/points-mall/goods',
    method: 'post',
    data: data
  });
}
function decorationPointsGoodsActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/points-mall/goods/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationPointsRedeemListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/points-mall/redeem/list',
    method: 'get',
    params: params
  });
}
function decorationPointsRedeemActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/points-mall/redeem/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationPlatformRuleApi() {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/platform-rule',
    method: 'get'
  });
}
function decorationPlatformRuleActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/platform-rule/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationDesignerRecruitListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/designer-recruit/list',
    method: 'get',
    params: params
  });
}
function decorationDesignerRecruitSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/designer-recruit',
    method: 'post',
    data: data
  });
}
function decorationDesignerRecruitActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/designer-recruit/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationDocDownloadListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/doc-download/list',
    method: 'get',
    params: params
  });
}
function decorationDocDownloadSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/doc-download',
    method: 'post',
    data: data
  });
}
function decorationDocDownloadActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/doc-download/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationOwnerApplyListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/owner-apply/list',
    method: 'get',
    params: params
  });
}
function decorationOwnerApplyActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/owner-apply/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationReferralRuleListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/referral-rule/list',
    method: 'get',
    params: params
  });
}
function decorationReferralRuleSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/referral-rule',
    method: 'post',
    data: data
  });
}
function decorationReferralRuleActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/referral-rule/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationAdSlotApi() {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/ad-slot',
    method: 'get'
  });
}
function decorationAdSlotActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/ad-slot/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationMallCategoryApi() {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/mall-category',
    method: 'get'
  });
}
function decorationMallCategoryActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/mall-category/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationRenovationPlanListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/renovation-plan/list',
    method: 'get',
    params: params
  });
}
function decorationRenovationPlanSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/renovation-plan',
    method: 'post',
    data: data
  });
}
function decorationRenovationPlanActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/renovation-plan/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationBasicProfileListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/basic-profile/list',
    method: 'get',
    params: params
  });
}
function decorationBasicProfileSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/basic-profile',
    method: 'post',
    data: data
  });
}
function decorationBasicProfileActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/basic-profile/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationSiteBasicListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/site-basic/list',
    method: 'get',
    params: params
  });
}
function decorationSiteBasicUpdateApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/site-basic/".concat(id),
    method: 'post',
    data: data
  });
}
function decorationSiteTeamListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/site-team/list',
    method: 'get',
    params: params
  });
}
function decorationSiteTeamSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/site-team',
    method: 'post',
    data: data
  });
}
function decorationSiteTeamActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/site-team/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function decorationSupervisionTeamListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/supervision-team/list',
    method: 'get',
    params: params
  });
}
function decorationSupervisionTeamSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/decoration/supervision-team',
    method: 'post',
    data: data
  });
}
function decorationSupervisionTeamActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/merchant/decoration/supervision-team/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}